import { Component, OnInit } from '@angular/core';
import { AppMetadataHandler } from 'app'

@Component({
  selector: 'app-claims-intimation-bulk-upload',
  templateUrl: 'claims-intimation-bulk-upload.component.html',
  styleUrls: ['claims-intimation-bulk-upload.component.scss']
})
export class ClaimsIntimationBulkUploadComponent implements OnInit {

  constructor(
    public appMetadataHandler: AppMetadataHandler
  ) { }

  ngOnInit() {
  }

  dataSet = [{},{}];
  
  handleFileUpload(data) {
    //DUMMY: Check ngzorro UPLOAD component's documentation for implementation sample 
    console.log(data);
  }

  /* Input Documents  */
  fileListEmpty = [];
  fileList = [
    {
      uid: 1,
      name: 'death_certificate_SCA23091.png',
      status: 'done',
      url: 'https://static.coindesk.com/wp-content/uploads/2019/02/Cert3.jpg'
    },
    {
      uid: 2,
      name: 'ID_proof_DCIM29921.png',
      status: 'done',
      url: 'https://i2.wp.com/www.techbulu.com/wp-content/uploads/2016/11/A_sample_of_Permanent_Account_Number_PAN_Card.jpg'
    },
    {
      uid: 3,
      name: 'ID_proof_back_CHRISHems.png',
      status: 'error',
      response: 'Server Error 500', // custom error message to show
      url: 'https://i2.wp.com/www.techbulu.com/wp-content/uploads/2016/11/A_sample_of_Permanent_Account_Number_PAN_Card.jpg'
    }
  ];
  
  /* Document Panel */
  docuPanelOpen = false;
  docuPanel(status){ this.docuPanelOpen = !!status }
  uploadArray = [{}];
  addUploadRow() {
    let objPush = {};
    this.uploadArray.push(objPush)
  }
  removeUploadRow(){
    this.uploadArray.pop();
  }


}
